// TODO: Hambre pa mañana...
// dsp va para el theme cuando entendamos bien todo el corso del layout.
export const SUB_LAYOUT_HEIGHT_MARGIN_LARGE = '64px';
export const SUB_LAYOUT_HEIGHT_MARGIN_SMALL = '132px';
export const TABLE_LAYOUT_HEIGHT_MARGIN_LARGE = '308px';
export const TABLE_LAYOUT_HEIGHT_MARGIN_SMALL = '384px';
export const HEADER_HEIGHT = 64;
export const HOTEL_SEARCH_UNDER_HEADER_HEIGHT = 124;
export const FLIGHT_SEARCH_UNDER_HEADER_HEIGHT = 178;
